/** ProductShell navigation; this parser grants no permissions. */
export type ContenedoresSection="agent"|"today"|"map"|"assets"|"dispatch"|"orders"|"quotes"|"customers"|"leads"|"finance"|"twin"|"knowledge"|"automation"|"settings";
const VALID=new Set<ContenedoresSection>(["agent","today","map","assets","dispatch","orders","quotes","customers","leads","finance","twin","knowledge","automation","settings"]);
export function contenedoresSection(path:string):ContenedoresSection{
  const segment=path.split("/").filter(Boolean)[0] ?? "";
  return VALID.has(segment as ContenedoresSection)?segment as ContenedoresSection:"agent";
}
